// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dG8X","col":"styles_col__3sxYq"};